"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var merge_1 = __importDefault(require("lodash/merge"));
var form_serialize_1 = __importDefault(require("./form-serialize"));
/**
 * Hook para auxiliar no gerenciamento de dados do formulário
 *
 * @param Object Valor inicial/default do formulário
 * @param Function callback de quando o formulário é submetido
 *
 * @example
 *
 * const [inputs, formOnChange, formOnSubmit, resetFormData, setFormData] = useForm({
 *    // ... form fields and values
 *    username: '',
 * }, formData => {
 *    // ... form submitted
 * })
 *
 * <form onChange={formOnChange} onSubmit={formOnSubmit}>
 *    // ... form fields
 *    <input type="text" name="username" value={inputs.username} />
 * </form>
 */
function useForm(initialData, callback) {
    var _a = react_1.useState(initialData), inputs = _a[0], setInputs = _a[1];
    /**
     * Captura o evento de submit do formulário e aciona o callback
     *
     * @param {*} event
     */
    var handleSubmit = react_1.useCallback(function (event) {
        if (event) {
            event.preventDefault();
            event.currentTarget.reset();
        }
        callback(inputs);
    }, [callback, inputs]);
    /**
     * Captura os eventos de mudança dos inputs do formulário
     * e armazena seus valores no state
     *
     * @param {*} event
     */
    var handleInputChange = react_1.useCallback(function (event) {
        if (event.persist) {
            event.persist();
        }
        var formData = form_serialize_1.default(event.currentTarget, {
            empty: true,
            disabled: true,
            hash: true,
        });
        // @ts-ignore
        var _a = event.target, name = _a.name, value = _a.value, type = _a.type;
        var moreFormData = {};
        if (['select-chip', 'multi-options', 'perfil-picker', 'volume-atendimento', 'calendar'].includes(type)) {
            moreFormData[name] = value;
        }
        setInputs(function (prevState) { return merge_1.default({}, prevState, moreFormData, formData); });
    }, [setInputs]);
    /**
     * Reseta os dados do formulário
     */
    var reset = react_1.useCallback(function () {
        if (JSON.stringify(initialData) !== JSON.stringify(inputs)) {
            setInputs(initialData);
        }
    }, [setInputs, initialData, inputs]);
    return [inputs, handleInputChange, handleSubmit, reset, setInputs];
}
exports.default = useForm;
